import React from "react"
import PropTypes from "prop-types"
import "./BsrToggle.scss"

class BsrComplianceToggle extends React.Component {
  render() {
    return (
      <div className="BsrComplianceToggle">
        <div className="toggle">
          <label className="toggle-switch">
            <div className="hidden">Toggle Switch</div>
            <input
              type="checkbox"
              checked={this.props.bsrCompliance}
              onChange={this.props.onChange}
            />
            <span className="switch" />
          </label>
        </div>
        <div className="text">Bedside Shift Report Compliance</div>
      </div>
    )
  }
}

BsrComplianceToggle.propTypes = {
  bsrCompliance: PropTypes.bool,
  onChange: PropTypes.func,
}

export default BsrComplianceToggle
